import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["marginTopIndicator", "indicatorPosition"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { ControlInputContainer } from '../../../internal/components/ControlInputContainer';
import { RadioToggle } from '../../../internal/components/RadioToggle';
import { generateDataTestId } from '../../../internal/utils';
import { useDeviceType } from '../../../responsive';
import { useIsMultiLine } from './useIsMultiLine';
import { calculateMarginTopIndicator } from './utils';
import { getStyles } from './styles';
import { UIText1, UIText2 } from '../../../typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RadioComponent = /*#__PURE__*/React.forwardRef(function Radio(props, ref) {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const {
      marginTopIndicator,
      indicatorPosition = 'top'
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  const {
    disabled,
    invalid,
    title,
    description,
    image,
    label,
    dataTestId
  } = restProps;
  const labelRef = React.useRef(null);
  const needCalculate = indicatorPosition === 'auto';
  const isMultiLine = useIsMultiLine(labelRef, needCalculate);
  const styles = getStyles(deviceType);
  const indicatorPositionIsTop = indicatorPosition === 'top' || indicatorPosition === 'auto' && isMultiLine;
  const marginTopIndicatorValue = calculateMarginTopIndicator({
    isMobile,
    isMultiLine,
    marginTopIndicator,
    indicatorPosition
  });
  return /*#__PURE__*/_jsxs(ControlInputContainer, _objectSpread(_objectSpread({}, restProps), {}, {
    type: "radio",
    className: clsx(styles['radio'], disabled && styles['disabled'], invalid && styles['invalid'], !!label && styles['hasLabel']),
    ref: ref,
    children: [/*#__PURE__*/_jsx(RadioToggle, {
      className: clsx(styles['indicator'], indicatorPositionIsTop && styles['indicator-top']),
      style: {
        top: "".concat(marginTopIndicatorValue, "px")
      }
    }), image && /*#__PURE__*/_jsx("span", {
      className: styles['image'],
      "data-testid": generateDataTestId(dataTestId, ['image']),
      children: image
    }), title && /*#__PURE__*/_jsxs("span", {
      ref: labelRef,
      className: styles['title'],
      children: [/*#__PURE__*/_jsx(UIText1, {
        color: "text-primary-default",
        "data-testid": generateDataTestId(dataTestId, ['title']),
        children: title
      }), description && /*#__PURE__*/_jsx(UIText2, {
        color: "text-secondary-default",
        "data-testid": generateDataTestId(dataTestId, ['description']),
        children: description
      })]
    }), label && /*#__PURE__*/_jsx("span", {
      ref: labelRef,
      className: styles['label'],
      "data-testid": generateDataTestId(dataTestId, ['label']),
      children: label
    })]
  }));
});

/**
 * Компонент простого radio с тайтлом
 *
 * По-умолчанию используем на десктопе. Не рекомендуем использовать на мобвебе из-за малой зоны тапа.
 *
 * [Ссылка на макет](https://www.figma.com/design/u5m0yseMVnhiC2eTOipMel/DS-89-Radio)
 *
 * @export
 * @param {IRadioProps} props
 * @returns
 */
export const Radio = /*#__PURE__*/React.memo(RadioComponent);